(function($){
  // Scroll to top onload
  // $(window).scrollTop(0);
  
  // Hero Section Slider
  function sortCollectionSlider() {
    var listWrapper = $(".vae-home-slider");
    var sortedItems = listWrapper.find("li").sort(function(a, b) { 
        var contentA = parseInt($(a).find('img').attr('alt').split('ssorder:')[1].split(']')[0]);
        var contentB = parseInt($(b).find('img').attr('alt').split('ssorder:')[1].split(']')[0]);
        return contentB > contentA ? -1 : contentA > contentB ? 1 : 0;
    });
    
    listWrapper.find("li").remove();
    listWrapper.append(sortedItems.slice(0,10)).bxSlider({
      mode: 'fade',
      auto: true,
      infiniteLoop: true,
      startSlide: 0,
      speed: 1000,
      controls: true,
      pager: true,
      maxSlides: 1,
      moveSlides: 1,
      pause: 4000,
      slideZIndex: 0,
      responsive: true,
      preloadImages: 'all',
      touchEnabled: (navigator.maxTouchPoints > 0)
    });
  }
  
  sortCollectionSlider();

  function collectionSlider(element, moveSlides, minSlides, maxSlides) {
    moveSlides = moveSlides || '4';
    minSlides = minSlides || '1';
    maxSlides = maxSlides || '4';
    var slidesWidth = '264';

    if (maxSlides === '3') {
      slidesWidth = '352';
    }

    var limitedItems = element.find('li').slice(0,10);

    element.find("li").remove();
    element.append(limitedItems).bxSlider({
      mode: 'horizontal',
      auto: false,
      infiniteLoop: true,
      startSlide: 0,
      speed: 1000,
      controls: true,
      pager: false,
      minSlides: minSlides,
      maxSlides: maxSlides,
      moveSlides: moveSlides,
      slideWidth: slidesWidth,
      slideZIndex: 0,
      responsive: true,
      preloadImages: 'visible',
      touchEnabled: (navigator.maxTouchPoints > 0)
    });
  }
  
  // Landing Page Collab List
  collectionSlider($('.home-collection-collab .vae-collection'));
  collectionSlider($('.home-collection-pickup .vae-collection'));
  collectionSlider($('.home-collection-artists .vae-collection'), '1', '3', '4');
  // collectionSlider($('.home-stories .vae-collection'), '1', '1', '3');
  
})(jQuery);